import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { collection, addDoc, doc, getDoc,} from 'firebase/firestore';
import { auth, db } from '../../Firebase/firebase';
import { PostsContext } from '../../contexts/PostsContext';
import { useAuth } from '../../contexts/AuthContext/index.jsx';
import { useActiveComponent } from '../../Components/ActiveComponentContext.js';
import LargePostCardDialog from '../../Components/LargePostCardDialog/index.jsx';
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LinearProgress from '@mui/material/LinearProgress';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import SearchBar from '../../Components/SearchBar/index.jsx';
import CategoryPostCard from '../../Components/CategoryPostCard/index.jsx';
import LargePostCard from '../../Components/LargePostCard/index.jsx';

const UserPostsPage = () => {
  // const { username } = useParams(); // Get the username from the URL
  const { userId } = useParams(); // Get the username from the URL
  const [longView, setLongView] = useState(true);

  const {
    currentUser,
    setShowAlertDialog,
    bookmarks, // Provide the bookmarks state
    toggleBookmark, // Provide the toggleBookmark function
  } = useAuth(); // Use the AuthContext to get current user

  const { categoriesData, loading } = useContext(PostsContext) || {}; // Access categories data and loading state
  const { backgroundColor } = useActiveComponent();
  const [isGridView, setIsGridView] = useState(true);
  const [userPosts, setUserPosts] = useState([]);
  //const [recoveredUsername, setRecoveredUsername] = useState("")
  const [loaded, setLoaded] = useState(false); // Track if posts have been fully loaded
  const [imageIndexes, setImageIndexes] = useState({}); // Store current index for each post
  const [openBioDialog, setOpenBioDialog] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const navigate = useNavigate();

  const handleOpenBioDialog = () => {
    setOpenBioDialog(true);
  };

  const handleCloseBioDialog = () => {
    setOpenBioDialog(false);
  };

  const handleCardClick = (cardData) => {
    if (!cardData) {
      console.error('Card data is not available');
      return;
    }
    setSelectedCard(cardData); // cardData now contains category too so above code not needed
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedCard(null);
  };
  //used when is bookmarked is stored in context:
  const handleBookmarkClick = (postId, title, summary, images) => {
    if (!currentUser) {
      setShowAlertDialog(true);
      setIsBookmarkForAlert(true);
      return;
    }

    //Does this need updating?
    toggleBookmark(postId, {
      creatorsUserId: userPosts[0].userId || null,
      title,
      summary,
      images,
      photoURL,
      username,
      //name,
      email,
      date,
      category,
      country: country || null,
      //city:city||null,
    });
  };

  const handleNextImage = (postId, images) => {
    setImageIndexes((prevIndexes) => {
      // Get the current index for the postId, default to 0 if undefined
      const currentIndex = prevIndexes[postId] ?? 0;
      // Increment the index or reset to 0 if it's the last image
      const nextIndex = (currentIndex + 1) % images.length;
      // Return the new indexes object with the updated index for this postId
      return {
        ...prevIndexes,
        [postId]: nextIndex,
      };
    });
  };

  const handlePrevImage = (postId, images) => {
    setImageIndexes((prevIndexes) => {
      // Get the current index for the postId, default to 0 if undefined
      const currentIndex = prevIndexes[postId] ?? 0;

      // Decrement the index or wrap around to the last image if it's 0
      const prevIndex = (currentIndex - 1 + images.length) % images.length;

      // Return the new indexes object with the updated index for this postId
      return {
        ...prevIndexes,
        [postId]: prevIndex,
      };
    });
  };

  const handleShare = (platform, id, title, description) => {
    const postUrl = `${window.location.origin}/post/${id}`;
    let shareUrl = '';
    const shareText = `${title}\n\n${description}\n\n${postUrl}`; // Including title, summary, and URL

    switch (platform) {
      case 'twitter':
        shareUrl = `https://twitter.com/share?url=${encodeURIComponent(
          postUrl
        )}&text=${encodeURIComponent(title)}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          postUrl
        )}&quote=${encodeURIComponent(shareText)}`;
        break;
      case 'email':
        shareUrl = `mailto:?subject=${encodeURIComponent(
          title
        )}&body=${encodeURIComponent(shareText)}`;
        break;
        break;
      case 'message':
        shareUrl = `sms:?body=${encodeURIComponent(shareText)}`;

        break;
      case 'copy':
        navigator.clipboard.writeText(postUrl);
        alert('Link copied to clipboard!');
        return;
      default:
        break;
    }
    if (shareUrl) {
      window.open(shareUrl, '_blank', 'noopener,noreferrer');
    }
  };

  // // let missingUsername
  // const getMissingUsername = async (userId) =>{
  //   //if (!username || username === "Anonymous") {
  //     try {
  //       // Fetch username from userData using userId
        
  //       const userDoc = await getDoc(doc(db, "users", userId));
  //       if (userDoc.exists()) {
  //         const userData = userDoc.data();
  //         // missingUsername = userData.username
  //         // console.log(missingUsername)
  //         return userData.username
  //         // path = `/${userData.username}`; // Use the fetched username
  //       }
  //     } catch (error) {
  //       console.error("Error fetching username:", error);
  //       return;
  //     }
  //   // }
    
  // }

  // useEffect(() => {
  //   const fetchUsername = async () => {
  //     const foundUsername = await getMissingUsername(userId); // Wait for async function to complete
  //     setRecoveredUsername(foundUsername); // Update state with retrieved username
  //   };
  //   fetchUsername();
  // }, [userId]); // Ensure `id` is available when useEffect runs
  

  useEffect(() => {
    if (!loading) {
      // Flatten categoriesData to get all posts in a single array
      const allPosts = Object.values(categoriesData).flat();
      // Filter posts for the specific user
      const filteredUserPosts = allPosts.filter(
        // (post) => post.username === username
        (post) => post.userId === userId
      );
      setUserPosts(filteredUserPosts);
      setLoaded(true); // Mark posts as loaded
    
    }
  }, [categoriesData, loading, userId]);



  // Extract the user's photoURL from the first post (if available)
  const userPhotoURL =
    userPosts.length > 0
      ? userPosts[0].userPhotoURL
      : '../images/siteImages/defaultAvatar.jpg';
  const userBannerImage =
    userPosts.length > 0
      ? userPosts[0].bannerImage
      : '../images/siteImages/dashboardDesign.png';
  const usersDisplayName =
    userPosts.length > 0 ? userPosts[0].displayName : 'N/A';
  const usersUsername = userPosts.length > 0 && userPosts[0].username ? userPosts[0].username : null;
  const userBio = userPosts.length > 0 ? userPosts[0].bio : 'N/A';
  const userLink = userPosts.length > 0 ? userPosts[0].link : 'N/A';

  // console.log(userPosts.length > 0)

  // console.log(recoveredUsername)

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg')); // Check if screen size is large or larger

  return (
    // <>
    <Box
      sx={{
        height: '100vh', // Full viewport height
        overflowY: 'auto', // Enable vertical scrolling of entire homepage
        mb: 0,
      }}
    >
      <Box
        sx={{
          display: { xs: 'flex', sm: 'flex', lg: 'none', xl: 'none' },
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          pb: 0.5,
          height: 45,
          ml: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
          position: 'sticky',
          top: 0,
          zIndex: 1000, // Ensure it's above other content while scrolling
        }}
      >
        <SearchBar width={300} />
      </Box>
      {/* {' '} */}
      {/* Loading Spinner */}
      {loading ? (
        <Box sx={{ width: '100%', mt: 2 }}>
          <LinearProgress />
        </Box>
      ) : (
        <>
          {/* Sticky header section with Typography and Tabs */}
          {loaded && userPosts.length > 0 && (
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1000, // Ensure it's above other content while scrolling
                backgroundColor: backgroundColor, // Set background so it's visible while scrolling
                p: 0.5,
                //border:'3px dashed red'
              }}
            >
              {/* Banner image */}
              <Box
                component='img'
                src={
                  userBannerImage || '../images/siteImages/dashboardDesign.png'
                }
                alt='dashboard-image'
                sx={{
                  width: {
                    xs: 330,
                    sm: 330,
                    md: 360,
                    lg: 1300,
                    xl: 1300,
                  },
                  objectFit: 'cover',
                  height: {
                    xs: '80px',
                    sm: '90px',
                    md: '110px',
                    lg: '120px',
                    xl: '120px',
                  },
                  borderRadius: '14px',
                  display: 'block',
                  margin: 'auto',
                  borderRadius: 4,
                  mt: 1,
                  mb: 2,
                  backgroundRepeat: 'repeat-x',
                }}
              />

              {/* User info section */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: { xs: '90%' },
                  mr: 'auto',
                  ml: 'auto',
                }}
              >
                <Avatar
                  src={userPhotoURL} // Set the Avatar's src to the user's photoURL
                  alt='User Avatar'
                  sx={{
                    width: { xs: 70, sm: 70, md: 110, lg: 120, xl: 120 },
                    height: { xs: 70, sm: 70, md: 110, lg: 120, xl: 120 },
                  }}
                />

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    ml: { xs: 1.5, sm: 1.5, md: 2, lg: 2.5, xl: 2.5 },
                    mt: 0,
                    gap: { xs: 1.5, sm: 1.5, md: 1.5, lg: 3, xl: 3 },
                    justifyContent: 'center',
                  }}
                >
                  {usersUsername && (
                    <Typography
                      variant='body1'
                      fontFamily='Montserrat'
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        fontSize: {
                          xs: '8px',
                          sm: '8px',
                          md: '8px',
                          lg: '11px',
                          xl: '11px',
                        },
                        fontWeight: 'bold',
                        maxHeight: '165px',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        gap: 0.5,
                      }}
                    >
                      @ {usersUsername}
                    </Typography>
                  )}
                  {userBio && (
                    <Box
                      sx={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        maxWidth: '400px',
                        width: {
                          xs: '220px',
                          sm: '220px',
                          md: '300px',
                          lg: '380px',
                          xl: '380px',
                        },
                      }}
                    >
                      <Typography
                        variant='body1'
                        fontFamily='Montserrat'
                        sx={{
                          fontSize: {
                            xs: '8px',
                            sm: '8px',
                            md: '8px',
                            lg: '11px',
                            xl: '11px',
                          },
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2, // Limit to 2 lines
                          '&:after': {
                            content: '"..."',
                            display: 'inline',
                            color: 'gray',
                          },
                        }}
                      >
                        {userBio}
                      </Typography>
                      <Typography
                        variant='body2'
                        sx={{
                          color: 'blue',
                          cursor: 'pointer',
                          mt: 0,
                          fontSize: {
                            xs: '8px',
                            sm: '8px',
                            md: '8px',
                            lg: '11px',
                            xl: '11px',
                          },
                          maxWidth: '400px',
                        }}
                        onClick={handleOpenBioDialog}
                      >
                        more
                      </Typography>
                    </Box>
                  )}

                  {userLink && (
                    <Typography
                      variant='body1'
                      fontFamily='Montserrat'
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        fontSize: {
                          xs: '8px',
                          sm: '8px',
                          md: '8px',
                          lg: '11px',
                          xl: '11px',
                        },
                        maxHeight: '165px',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        gap: 0.5,
                      }}
                    >
                      <a
                        href={
                          userLink.startsWith('http://') ||
                          userLink.startsWith('https://')
                            ? userLink
                            : `https://${userLink}`
                        }
                        target='_blank'
                        rel='noopener noreferrer'
                        style={{ color: 'blue', fontStyle: 'italic' }}
                      >
                        {userLink || 'N/A'}
                      </a>
                    </Typography>
                  )}
                </Box>
                {/* Dialog for Full User Bio */}
                <Dialog
                  open={openBioDialog}
                  onClose={handleCloseBioDialog}
                  maxWidth='sm'
                >
                  <DialogTitle>
                    About
                    <IconButton
                      edge='end'
                      color='inherit'
                      onClick={handleCloseBioDialog}
                      aria-label='close'
                      sx={{
                        position: 'absolute',
                        right: 12,
                        top: 0,

                        '&:hover': {
                          transform: 'scale(1.12)', // Optional: adds a slight zoom effect
                          transition:
                            'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                        },
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <Typography variant='body1' fontFamily='Montserrat'>
                      {userBio}
                    </Typography>
                  </DialogContent>

                  <DialogTitle>Link</DialogTitle>
                  <DialogContent>
                    <Typography variant='body1' fontFamily='Montserrat'>
                      {userLink ? (
                        <a
                          href={
                            userLink.startsWith('http://') ||
                            userLink.startsWith('https://')
                              ? userLink
                              : `https://${userLink}`
                          }
                          target='_blank'
                          rel='noopener noreferrer'
                          style={{ color: 'blue', fontStyle: 'italic' }}
                        >
                          {userLink || 'N/A'}
                        </a>
                      ) : (
                        'N/A'
                      )}
                    </Typography>
                  </DialogContent>
                </Dialog>
              </Box>
              {loaded && userPosts.length > 0 && (
                <IconButton
                  disableRipple
                  // sx={{ ml: '96%', '&:hover': { color: 'black' } }}
                  sx={{
                    ml: 'auto',
                    ml: {
                      xs: '86%',
                      sm: '86%',
                      md: '86%',
                      lg: '96%',
                      xl: '96%',
                    },
                    '&:hover': { color: 'black' },
                  }}
                  onClick={() => setIsGridView(!isGridView)}
                >
                  {isGridView ? (
                    <ViewAgendaIcon sx={{ fontSize: 26 }} />
                  ) : (
                    <ViewModuleIcon sx={{ fontSize: 26 }} />
                  )}
                </IconButton>
              )}
              {/* </Box> */}
            </Box>
          )}

          <Box
            sx={{
              mt: 0,
              mb: 2,
              pt: 1,
              pb: 2,
              display: 'flex',
              justifyContent: isGridView
                ? isLgUp && parseInt(userPosts.length) >= 4
                  ? 'flex-start'
                  : 'center'
                : 'center',
              flexDirection: !isGridView && isLgUp && 'column',
              ml: 'auto',
              mr: 'auto',
              boxSizing: 'border-box',
              maxWidth: '100%',
              flexWrap: 'wrap',
              overflowY: 'auto', // Enable vertical scrolling
              width: '100%',
            }}
          >
            {/* toggle button */}
            {/* LARGEST BOX WHere all content of card goes */}
            <Box
              sx={{
                gap: 5,
                mt: 0,
                mb: 0,
                ml: 1,
                mr: 1,
                display: 'flex',
                overflowY: 'auto',
                flexWrap: longView ? 'wrap' : 'none',
                justifyContent: longView && 'center',
                width: longView
                  ? { xs: '90%', sm: '95%', md: '85%', lg: '100%', xl: '100%' }
                  : { xs: '90%', sm: '95%', md: '85%', lg: '80%', xl: '80%' },
                alignItems: !longView && 'flex-start',
                flexDirection: !longView && 'row',
                overflowY: !longView && 'hidden',
                overflowX: !longView && 'auto',
              }}
            >
              {loading ? (
                <Box sx={{ width: '60%', ml: 'auto', mr: 'auto', mt: '0%' }}>
                  <LinearProgress />
                </Box>
              ) : loaded && userPosts.length === 0 ? (
                <p>No posts available for this user.</p> // Show when there are no posts after loadin
              ) : (
                userPosts.map((post) => {
                  const postId = post.id; // Make sure this matches how your posts are structured
                  const isBookmarked = bookmarks[postId] || false; // Check if the post is bookmarked
                  const currentIndex = imageIndexes[post.id] || 0;
                  return isGridView ? (
                    // <Grid item xs={6} sm={6} md={4} key={post.id}>
                    <Box key={post.id} sx={{ display: 'flex' }}>
                      <CategoryPostCard
                        key={post.id}
                        images={post.images || []}
                        title={post.title}
                        summary={post.description}
                        postID={post.id}
                        photoURL={post.userPhotoURL}
                        username={post.username}
                        name={post.name}
                        email={post.email}
                        date={post.readableDate}
                        category={post.category}
                        location={post.location || null}
                        onClick={() => handleCardClick(post)}
                        vertical='260px'
                        horizontal='300px'
                      />
                    </Box>
                  ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <LargePostCard
                        key={post.id}
                        id={post.userId}
                        images={post.images || []}
                        title={post.title}
                        summary={post.description}
                        postID={post.id}
                        photoURL={post.userPhotoURL}
                        username={post.username}
                        name={post.name}
                        email={post.email}
                        date={post.readableDate}
                        category={post.category}
                        country={post.location.country || null}
                        onClick={() => handleCardClick(post)}
                        vertical='300px'
                        horizontal='680px'
                      />
                    </Box>
                  );
                })
              )}
            </Box>
            {/* PopUp Dialog displaying LargePostCardDialog */}
            {selectedCard && (
              <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth='lg'
                fullWidth
                PaperProps={{
                  style: {
                    maxHeight: 'calc(100vh - 15px)',
                    overflowY: 'auto',
                    height: '85vh',
                    borderRadius: '24px',
                  },
                }}
              >
                <DialogTitle sx={{ mb: 1, p: 2 }}>
                  {/* {selectedCard.title} */}
                  <IconButton
                    aria-label='close'
                    onClick={handleCloseDialog}
                    sx={{
                      position: 'absolute',
                      right: { xs: 2, sm: 2, md: 4, lg: 8, xl: 8 },
                      top: { xs: 1, sm: 1, md: 3, lg: 8, xl: 8 },
                      color: (theme) => theme.palette.grey[500],
                      '&:hover': {
                        backgroundColor: 'indianred',
                        color: 'white',
                      },
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent
                  sx={{
                    mt: 0,
                    mb: 0,
                    p: 0,
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <LargePostCardDialog
                    id={selectedCard.userId}
                    postID={selectedCard.id}
                    images={selectedCard.images}
                    title={selectedCard.title}
                    summary={selectedCard.description}
                    link={selectedCard.link}
                    ratings={selectedCard.ratings}
                    postInfo={selectedCard} // Pass the whole object
                    photoURL={selectedCard.userPhotoURL}
                    username={selectedCard.username} //pass the username to LargePostCard
                    name={selectedCard.name}
                    email={selectedCard.email}
                    date={selectedCard.readableDate}
                    category={selectedCard.category}
                    location={selectedCard.location || null}
                  />
                </DialogContent>
              </Dialog>
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

export default UserPostsPage;
